import { call, put, takeEvery, takeLatest } from "redux-saga/effects";

import {
  ADD_PRESCREENING_QUESTION,
  GET_SELECTED_PRESCREENING_QUESTION_FROM_QUESTION_BANK,
  SEARCH_PRESCREENING_QUESTION_FROM_QUESTION_BANK,
  UPDATE_PRESCREENING_QUESTION
} from "./actionTypes";
import {
  PrescreeningSelectedListFail,
  PrescreeningSelectedListSuccess,
  addNewPreScreeningFail,
  addNewPreScreeningSuccess,
  getpreScreeningAssesmentListFailed,
  getpreScreeningAssesmentListSuccess,
  upDatePreScreeningFail,
  upDatePreScreeningSuccess
} from './actions';

import { getassesment, postAssesmentQuestions } from "../../../helpers/fakebackend_helper";

//restapi end point
import * as constClass from "../../../common/constant/constantURL";
import { verifyData } from "../../../pages/Common/CommonFunctions/commonFunctions";

function* searchScreeningQuestionsListHandler (data){
  try{   
   let url = constClass.REST_API_SCREENING_GET_QUESTIONBANK_LIST+`?page=${data.payload.pageNumber}&pageSize=10&jobId=0`
   if(data.payload.keyWord !== undefined && data.payload.keyWord !== null && data.payload.keyWord  !== ""){
      url = url+`&keyword=${data.payload.keyWord}&type=${(data.payload?.type)}`
     
     }else if(data.payload.selectedQuestions !== undefined && data.payload.selectedQuestions !== null && data.payload.selectedQuestions  !== ""){
      url= url+`&type=${(data.payload?.type)}`
     }
     else if(data.payload?.type !== undefined && data.payload?.type !== null && data.payload?.type  !== ""){
      url= url+`&type=${(data.payload?.type)}`
     }
     if(verifyData(data.payload.jobId)){
     url = url+`&jobId=${ data.payload.jobId}`
     }
   let responsJSON = yield call(getassesment, decodeURIComponent(url))
   yield put(getpreScreeningAssesmentListSuccess(responsJSON))
  }
  catch(error){
    yield put(getpreScreeningAssesmentListFailed(error))
  }
}

function* addNewPrescreeningQuestionHandler({payload: {data}}){
      try {
        let url = constClass.REST_API_SCREENING_GET_QUESTIONBANK_LIST
        let responsJSON = yield call(postAssesmentQuestions, url, data)
        yield put(addNewPreScreeningSuccess("responsJSON"))
      }
      catch(error){
        yield put(addNewPreScreeningFail(error))
      }
}

function* upDatePrescreeningQuestionHandler({payload: {data}}){
  try {
    let url = constClass.REST_API_SCREENING_POST_QUESTIONBANK
    let tempData = data
     tempData.screeningQuestions.filter((item)=>{delete item["type"]})
    let responsJSON = yield call(postAssesmentQuestions, url, tempData)
    yield put(upDatePreScreeningSuccess("responsJSON"))
  }
  catch(error){
    yield put(upDatePreScreeningFail(error))
  }
}

function* SelectedPrescreeningQuestionHandler({payload:{data}}){
  try {
    let url = constClass.REST_API_SCREENING_POST_QUESTIONBANK+`?jobId=${data}`
    
    let responsJSON = yield call(getassesment, url)
    yield put(PrescreeningSelectedListSuccess(responsJSON))
  }
  catch(error){
    yield put(PrescreeningSelectedListFail(error))
  }
}


function* PrescreeningQuestionsSaga() {
    yield takeLatest(SEARCH_PRESCREENING_QUESTION_FROM_QUESTION_BANK, searchScreeningQuestionsListHandler)
    yield takeLatest(ADD_PRESCREENING_QUESTION, addNewPrescreeningQuestionHandler)
    yield takeLatest(UPDATE_PRESCREENING_QUESTION ,upDatePrescreeningQuestionHandler)
    yield takeEvery(GET_SELECTED_PRESCREENING_QUESTION_FROM_QUESTION_BANK, SelectedPrescreeningQuestionHandler)
  }
  
  export default PrescreeningQuestionsSaga